import * as React from 'react';

import { Translate } from 'react-localize-redux';

import styled from 'styled-components';

import Typography from '@components/basics/typography';
import MotionOpacity from '@components/motion/motion-opacity';

import SecurityPasswordCtrl from '@webapp/controllers/security/password';
import AppState from '@webapp/store/state';
import { connect } from 'react-redux';
//import SecurityTwoFactorCtrl from '@webapp/controllers/security/two-factor';

interface SecurityGeneralPageProps {
  className?: string;
  isMobile: boolean;
}

const mapsStateToProps = (state: AppState) => ({
  isMobile: state.ui.mobile,
});

export const SecurityGeneralPage: React.FC<SecurityGeneralPageProps> = (
  props
) => {
  return (
    <MotionOpacity className={props.className}>
      {!props.isMobile ? (
        <Typography type="subheader" customFont="semi-bold" className="mb-30">
          <Translate id="USER_PROFILE.SECURITY.TITLE" />
        </Typography>
      ) : null}
      <Wrapper>
        <SecurityPasswordCtrl />
        {/*<SecurityTwoFactorCtrl />*/}
      </Wrapper>
    </MotionOpacity>
  );
};

export default connect(mapsStateToProps)(SecurityGeneralPage);

const Wrapper = styled.div`
  display: grid;
  grid-gap: 3px;
`;
